import { withStyles } from '@material-ui/core/styles';

import Keypad from './Keypad';
import styles from './Keypad.styles';

export default withStyles(styles)(Keypad);
